import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import CarousalImg from "../../../assets/Images/Carousel-1.webp";
import CSM from "../../../assets/Images/CSM.webp";
import Appmin from "../../../assets/Images/APP-min.webp";

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    cssEase: "linear",
    pauseOnHover: true,
  };

  return (
    <Slider {...settings}>
      <div className="carousal">
        <img src={CarousalImg} alt="" className="carousal_img" />
        <div className="carousal_content">
          <h3 className="carousal_content_heading">Video Portal</h3>
          <p className="carousal_content_text">
            Reach out to thousands of students through your educational lectures
            and grow your brand in the fastest way possible. Host your video
            lectures securely and share access with only who you want to.
          </p>
          {/* <button className="carousal_content_btn">
            <Link to="/features">Know more</Link>
          </button> */}
        </div>
      </div>

      <div className="carousal">
        <img src={CSM} alt="" className="carousal_img" />
        <div className="carousal_content">
          <h3 className="carousal_content_heading">Online Test Portal</h3>
          <p className="carousal_content_text">
            Conducting online tests without the hassle of checking is now
            possible! Give your students enough practice by using our online
            test portal. Automatically upload all your question papers.
          </p>
          {/* <button className="carousal_content_btn">
            <Link to="/features">Know more</Link>
          </button> */}
        </div>
      </div>

      <div className="carousal">
        <img src={Appmin} alt="" className="carousal_img" />
        <div className="carousal_content">
          <h3 className="carousal_content_heading">
            Your Coaching’s Mobile App
          </h3>
          <p className="carousal_content_text">
            One single mobile app by your coaching institute's name that can
            help you in becoming a digital brand. Digitise all your academic
            activities through the platform and give your students and their
            parents with the experience they desire for!
          </p>
          {/* <button className="carousal_content_btn">
            <Link to="/features">Know more</Link>
          </button> */}
        </div>
      </div>
    </Slider>
  );
};

export default Carousel;
